import { IWholesalePage, IWholeSalePlates } from '../components/types'
import { wholesale_elements_nodes } from '../__generated__/wholesale'

export const createWholeSalePage = (
  elements: wholesale_elements_nodes[],
): IWholesalePage => {
  if (!elements) {
    return null
  }

  const mainElem = elements?.filter((el) => el.code === 'title')[0]
  const title = mainElem?.name
  const description = mainElem?.detailText

  const plates: IWholeSalePlates[] = elements
    ?.filter((el) => el.code.includes('plates'))
    ?.map((el) => ({
      id: el.id,
      title: el.name,
      description: el?.detailText,
      img: el.detailPicture?.url,
    }))

  return {
    title,
    description,
    plates,
  }
}
